import React from 'react';

const CategoryEdit = (props) => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div>
            <label className="form-label label-txt"> Product Name</label>
            <input type="text" className="form-control" defaultValue={props.productDetails && props.productDetails.name}
              onChange={(e) => props.setProductDetails({ ...props.productDetails, name: e.target.value })}
            />
            {props.error ? <p style={{ fontSize: 12, color: 'red' }}> {props.error.product_name}</p> : ''}
          </div>

          <div className='col-md-4 mt-2'>
            <label className="form-label label-txt">Select Category</label>
            <select className="form-select" onChange={(category_id) => {
              props.handleCategoryFirst(category_id.target.value)
            }}
              defaultValue={props.productDetails && props.productDetails.category_id}
            >
              <option disabled selected> Select Category</option>
              {props.categoryData && props.categoryData.map((item, index) => {
                return (<option key={index} value={item.id}>{item.name}</option>)
              })}
            </select>
            {props.error ? <p style={{ fontSize: 12, color: 'red' }}> {props.error.category_id}</p> : ''}
          </div>

          <div className='col-md-4 mt-2'>
            <label className="form-label label-txt col-md-7">Select Sub Category</label>
            <select className="form-select" disabled={props.disabled}
              onChange={(sub_category_id) => {
                props.handleCategorySecond(sub_category_id.target.value)
              }}
              value={props.productDetails && props.productDetails.sub_category_id ? props.productDetails.sub_category_id : ""}
            >
              <option disabled selected> Select Sub Category</option>
              {props.subCategoryData && props.subCategoryData.map((item, index) => {
                return (<option key={index} value={item.id}>{item.name}</option>)
              })}
            </select>
            {props.error ? <p style={{ fontSize: 12, color: 'red' }}> {props.error.sub_category_id}</p> : ''}
          </div>

          <div className='col-md-4 mt-2'>
            <label className="form-label label-txt col-md-7">Select Last Category</label>
            <select className="form-select" disabled={props.disabled2}
              onChange={(third_category_id) => {
                props.handleCategoryLast(third_category_id.target.value)
              }}
              value={props.productDetails && props.productDetails.third_category_id ? props.productDetails.third_category_id : ""}
            >
              <option disabled selected> Select Last Category</option>
              {props.lastCategoryData && props.lastCategoryData.map((item, index) => {
                return (<option key={index} value={item.id}>{item.name}</option>)
              })}
            </select>
            {props.error ? <p style={{ fontSize: 12, color: 'red' }}> {props.error.third_category_id}</p> : ''}
          </div>

          <div className='col-md-12 mt-2'>
            <label className="form-label label-txt col-md-7">Brand Option</label>
            <div className="d-flex gap-4 mb-2">
              <div className="form-check" style={{ fontSize: '15px' }}>
                <input className="form-check-input" type="radio" name="edit_is_brand" id="editBrandYes" value="1"
                  checked={(props.productDetails && props.productDetails.is_brand) != '2'}
                  onChange={(e) => props.setProductDetails({ ...props.productDetails, is_brand: '1' })}
                  style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }} />
                <label className="form-check-label ms-2" htmlFor="editBrandYes" style={{ cursor: 'pointer' }}>Brand</label>
              </div>
              <div className="form-check" style={{ fontSize: '15px' }}>
                <input className="form-check-input" type="radio" name="edit_is_brand" id="editBrandNo" value="2"
                  checked={(props.productDetails && props.productDetails.is_brand) == '2'}
                  onChange={(e) => props.setProductDetails({ ...props.productDetails, is_brand: '2' })}
                  style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }} />
                <label className="form-check-label ms-2" htmlFor="editBrandNo" style={{ cursor: 'pointer' }}>Non Brand</label>
              </div>
            </div>
          </div>

          {(props.productDetails && props.productDetails.is_brand === '2') ? null : (
            <div className='col-md-12 mt-2'>
              <label className="form-label label-txt col-md-7">Select Brand</label>
              <select className="form-select"
                onChange={(e) => {
                  e.preventDefault();
                  props.setProductDetails({ ...props.productDetails, brand_id: e.target.value })
                }}
                value={props.productDetails && props.productDetails.brand_id ? props.productDetails.brand_id : ""}>
                <option disabled value=""> Select  Brand</option>
                {props.brandData && props.brandData.map((item, index) => {
                  return (<option key={index} value={item.brand_id}>{item.brand_name}</option>)
                })}
              </select>
              {props.error ? <p style={{ fontSize: 12, color: 'red' }}> {props.error.brand_id}</p> : ''}
            </div>
          )}

          {props.productDetails && props.productDetails.weight != null ?
            <div className="col-md-3 mt-2">
              <label className="form-label label-txt"> Weight (g)</label>
              <input type="text" className="form-control" defaultValue={props.productDetails && props.productDetails.weight}
                onChange={(e) => props.setProductDetails({ ...props.productDetails, weight: e.target.value })}
              />
            </div> : ''
          }

          {props.productDetails && props.productDetails.height != null ?
            <div className='col-md-3 mt-2'>
              <label className="form-label label-txt"> Height (cm)</label>
              <input type="text" className="form-control" defaultValue={props.productDetails && props.productDetails.height}
                onChange={(e) => props.setProductDetails({ ...props.productDetails, height: e.target.value })}
              />
            </div> : ''
          }

          {props.productDetails && props.productDetails.width != null ?
            <div className='col-md-3 mt-2'>
              <label className="form-label label-txt"> Width (cm)</label>
              <input type="text" className="form-control" defaultValue={props.productDetails && props.productDetails.width}
                onChange={(e) => props.setProductDetails({ ...props.productDetails, width: e.target.value })}
              />
            </div> : ''
          }

          {props.productDetails && props.productDetails.length != null ?
            <div className='col-md-3 mt-2'>
              <label className="form-label label-txt"> Length (cm)</label>
              <input type="text" className="form-control" defaultValue={props.productDetails && props.productDetails.length}
                onChange={(e) => props.setProductDetails({ ...props.productDetails, length: e.target.value })}
              />
            </div> : ''
          }

          <div className='col-md-3 mt-2'>
            <label className="form-label label-txt"> GST (%)</label>
            <select className="form-select"
              value={props.productDetails && props.productDetails.gst != null ? String(parseInt(props.productDetails.gst)) : ""}
              onChange={(e) => props.setProductDetails({ ...props.productDetails, gst: e.target.value })}>
              <option disabled value="">Select GST</option>
              <option value="0">0%</option>
              <option value="5">5%</option>
              <option value="12">12%</option>
              <option value="18">18%</option>
              <option value="28">28%</option>
            </select>
          </div>

          <div className="col-md-12 mt-2">
            <label className="form-label label-txt col-md-7">Short Description</label>
            <textarea defaultValue={props.productDetails && props.productDetails.short_description}
              className="form-control"
              aria-label="With textarea"
              onChange={(e) => props.setProductDetails({ ...props.productDetails, short_description: e.target.value })}
            ></textarea>
            {props.error ? <p style={{ fontSize: 12, color: 'red' }}> {props.error.short_description}</p> : ''}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CategoryEdit;